import $foreign from "./foreign.cjs";
var catchException = $foreign.catchException;
var error = $foreign.error;
var message = $foreign.message;
var name = $foreign.name;
var showErrorImpl = $foreign.showErrorImpl;
var stackImpl = $foreign.stackImpl;
var throwException = $foreign.throwException;
export { catchException, error, message, name, showErrorImpl, stackImpl, throwException };
